import axiosInstance from '../../functions/axiosInstance';
import server_config from "../../ServerConfiguration";

const fevir_node_server_address = server_config["fevir_node_server_address"];

const createNetBenefitCalculator = async (apiToken = null, foi = null, title = null, category = null) => {
    if (!(apiToken && foi && title)) {
        alert("Missing something!");
        return;
    }
    await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'createnetbenefitcalculator',
            'apiToken': apiToken,
            'foi': foi,
            'title': title,
            'category': category
        },
    }).then((resp) => {
        if (resp?.data) {
            console.log(resp.data)
            //resp.data includes { success: true }
            if (resp.data.success) {
                alert("Success");
            } else {
                alert("Problem creating the Net Benefit Calculator");
            }
        } else {
            console.log("NO RESPONSE from createnetbenefitcalculator call");
        }
    }).catch((error) => { console.log(error); });
}

export default createNetBenefitCalculator;